/** Zona horaria de referencia para el cierre de la oferta (Argentina, UTC−3, sin horario de verano) */
const OFFSET_HOURS = -3;
const RESET_HOUR = 12;
const DAY_MS = 24 * 60 * 60 * 1000;

/** Milisegundos que faltan para el próximo mediodía (12:00) en hora de Argentina */
export function msUntilNextNoon(now: number = Date.now()): number {
  const resetUtcHour = RESET_HOUR - OFFSET_HOURS; // 15:00 UTC
  const d = new Date(now);
  let target = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), resetUtcHour, 0, 0);
  if (target <= now) target += DAY_MS;
  return target - now;
}

export function splitDuration(ms: number) {
  const total = Math.max(0, Math.floor(ms / 1000));
  return {
    hours: Math.floor(total / 3600),
    minutes: Math.floor((total % 3600) / 60),
    seconds: total % 60,
  };
}

export function pad(n: number): string {
  return String(n).padStart(2, "0");
}
